'use client'
import { getProductDetail } from '@/services/product/get-product'
import { ProductResponse } from '@/types/product'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export default function useGetProductDetail(customId: string, queryOptions?: UseQueryOptions) {
  const query = useQuery({
    queryKey: ['get-product-detail', customId],
    queryFn: async () => {
      try {
        const response = await getProductDetail(customId)
        return response.data as ProductResponse
      } catch (err: any) {
        if (err.response?.status === 404) {
          return null
        }
        throw err
      }
    },
    enabled: !!customId,
    ...queryOptions,
  })

  // Kiểm tra nếu là lỗi 404
  const isNotFound = query.error && (query.error as any)?.response?.status === 404

  return {
    data: query.data as ProductResponse | undefined,
    isLoading: query.isLoading,
    error: query.error,
    isNotFound,
    refetch: query.refetch,
    query,
  }
}
